module.exports = __webpack_public_path__ + "static/media/feature-6.0de60849.jpg";